import axios from 'axios';

export const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xMjcuMC4wLjE6ODAwMFwvYXBpXC9hdXRoXC9sb2dpbiIsImlhdCI6MTY3ODYyNDk2NywiZXhwIjoxNjc4NjI4NTY3LCJuYmYiOjE2Nzg2MjQ5NjcsImp0aSI6Ikw2TGxybWlDUms4TmpqTTkiLCJzdWIiOjEsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjcifQ.HYMIaihgQKCvh1bSqVy8XmrxuFtE18W_VWJsGoYv-9g';

export const AgendaFilePath = '/upload/ICDRI_2023_Agenda.pdf';

export const fetchDetails = async (url, param1 = null, param2 = null) => {

    try {
        const response = await axios.get(url, {
            headers: {
                'Cache-Control': 'max-age=300', // cache for 1 minute
                'Authorization': `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export function getParsedDate(date) {
    date = String(date).split(' ');
    const days = String(date[0]).split('-');
    const hours = String(date[1]).split(':');
    const fhours = hours[0] + hours[1] + String(' ');

    return (fhours);
}

export function getDateString(date) {
    date = String(date).split(' ');
    const days = String(date[0]);
    const dayssplit = String(days).split('-');
    const finaldate = dayssplit[2] + String(' ') + getMonthName(dayssplit[1]) + String(' ') + dayssplit[0];
    // const days = new Date(2021, 2, 3)
    const hours = String(date[1]).split(':');
    const fhours = hours[0] + hours[1] + String(' ');

    return (finaldate);
}

function getMonthName(monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);

    return date.toLocaleString('en-US', {
        month: 'long',
    });
}

export function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}



// const cache = {};

// export async function fetchData(apiUrl, urls) {
//     const promises = [];

//     console.log(apiUrl);

//     urls.forEach(url => {
//         if (cache[url]) {
//             promises.push(Promise.resolve(cache[url]));
//         } else {
//             const promise = axios.get(apiUrl + url).then(response => {
//                 cache[url] = response.data;
//                 return response.data;
//             });
//             promises.push(promise);
//         }
//     });

//     const responses = await Promise.all(promises);
//     return responses;
// }

// export async function fetchData(apiUrl, urls) {
//     const responses = await Promise.all(urls.map(url => axios.get(apiUrl + url)));
//     return responses.map(response => response.data);
// }